import React, { useMemo } from "react";
import useClientOptions from "../hooks/useClientOptions";
import "../assets/css/ClientLeadsFilter.css";

export const TUMMA_CLIENT = "tumma";
export const TUMMA_LEAD_TYPES = ["Business Leads", "Training Leads", "Job Leads", "Internship Leads"];

/**
 * Client Leads Search bar: Tumma (own Business / Training / Job / Internship leads) or a client
 * (that client's own leads). Business Type and Include Inactive narrow the client list.
 */
export default function ClientLeadsFilter({
  client,
  leadType,
  businessTypeId,
  includeInactive,
  onClientChange,
  onLeadTypeChange,
  onBusinessTypeChange,
  onIncludeInactiveChange,
}) {
  const clients = useClientOptions();
  const isTumma = client === TUMMA_CLIENT;

  const businessTypes = useMemo(() => {
    const seen = new Map();
    clients.forEach((c) => {
      if (c.domainId && !seen.has(c.domainId)) seen.set(c.domainId, c.domainName || `Type #${c.domainId}`);
    });
    return [...seen.entries()]
      .map(([id, name]) => ({ id, name }))
      .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
  }, [clients]);

  const visibleClients = useMemo(
    () =>
      clients.filter(
        (c) =>
          c.id === String(client || "") ||
          ((includeInactive || c.isActive) && (!businessTypeId || c.domainId === String(businessTypeId)))
      ),
    [clients, includeInactive, businessTypeId, client]
  );

  return (
    <div className={`client-leads-filter${isTumma ? " client-leads-filter--tumma" : ""}`}>
      <label className="client-leads-filter__field client-leads-filter__client">
        <span>Client</span>
        <select
          className="search-filter-input search-filter-select"
          value={client || ""}
          onChange={(e) => onClientChange(e.target.value)}
        >
          {!client ? <option value="">Select a client…</option> : null}
          <option value={TUMMA_CLIENT}>Tumma</option>
          {visibleClients.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
              {c.isActive ? "" : " (Inactive)"}
            </option>
          ))}
        </select>
      </label>
      <label className="client-leads-filter__field client-leads-filter__btype">
        <span>Business Type</span>
        <select
          className="search-filter-input search-filter-select"
          value={businessTypeId || ""}
          onChange={(e) => onBusinessTypeChange(e.target.value)}
        >
          <option value="">All business types</option>
          {businessTypes.map((b) => (
            <option key={b.id} value={b.id}>
              {b.name}
            </option>
          ))}
        </select>
      </label>
      {isTumma ? (
        <label className="client-leads-filter__field client-leads-filter__ltype">
          <span>Lead Type</span>
          <select
            className="search-filter-input search-filter-select"
            value={leadType}
            onChange={(e) => onLeadTypeChange(e.target.value)}
          >
            {TUMMA_LEAD_TYPES.map((t) => (
              <option key={t} value={t}>
                {t.replace(" Leads", "")}
              </option>
            ))}
          </select>
        </label>
      ) : null}
      <label className="client-leads-filter__field client-leads-filter__check">
        <span>In-Active</span>
        <input
          type="checkbox"
          className="client-leads-filter__check-box"
          checked={Boolean(includeInactive)}
          onChange={(e) => onIncludeInactiveChange(e.target.checked)}
        />
        <span className="client-leads-filter__switch-text">Inactive</span>
      </label>
      {!client ? <span className="client-leads-filter__hint">Select Tumma or a client to load leads.</span> : null}
    </div>
  );
}
